module.exports = __webpack_public_path__ + "img/2024-08-29d_1.ec213b19.jpg";